query DepartmentBudgets(  $filter: DepartmentBudgetFilter)
{
  departmentBudgets(
        orderBy: [DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC, DEPARTMENT_BUDGET_TYPE_BY_BUDGET_TYPE_ID__BUDGET_TYPE_ASC]
        filter: $filter
  ) {
        nodes {
          id
          budgetAmount
          departmentId
          department {
            name
          }
          businessUnitId
          businessUnit {
            name
          }
          departmentBudgetType {
            budgetType
          }
          budgetTypeId
          currencyId
          companyCurrency {
            name
          }
          lookupAccountId
          lookupAccount {
            lookupAccount
            lookupName
          }
          budgetAmount
          _isUpdatable
          _isDeletable
          _rowTimestamp
        }
      }
}
